<template>
  <div v-if="displayThemeInfo" class="theme-info mb-4">
    <div class="flex justify-between mb-1">
      <h3 qaid="rail-theme-info-name" class="theme-info__name font-heading text-lg" v-html="themeName" />
      <span
        v-if="isHidingPrices"
        qaid="rail-theme-info-price"
        class="theme-info__price text-md"
        v-html="bp('priceVaries')"
      />
      <span
        v-else-if="b2b && !consumerFriendlyMode"
        qaid="rail-theme-info-price"
        class="theme-info__price text-blue text-md"
        v-html="bikeData.themeDealerCost"
      />
      <span
        v-else
        qaid="rail-theme-info-price"
        class="theme-info__price text-blue text-md"
        v-html="bikeData.themeAdvertised"
      />
    </div>
    <div v-if="bikeEtaVisible" class="flex items-center text-gray-60 text-sm leading-none">
      <i qaid="rail-theme-info-eta-icon" class="material-icons md-18 mr-25">schedule</i>
      <span qaid="rail-theme-info-eta" v-html="`${bikeEta} ${bp('buildTime')}`" />
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    displayThemeInfo() {
      return this.bikeData !== null;
    },

    themeName() {
      return this.bikeData?.themeName ?? this.bikeData?.modelName;
    },

    ...mapState('backend', ['b2b', 'consumerFriendlyMode']),
    ...mapState('projectOne', ['bikeData', 'bikeEta', 'bikeEtaVisible', 'isHidingPrices']),
  },
};
</script>
